import * as React from 'react';

import type Moment from 'moment';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {SelectTimePicker} from 'shells/select-time-picker/select-time-picker';

import type {SetAvailability_availabilitySet_availability_times as AvailabilityTime} from 'nutshell-graphql-types';

import {convertTimeStringToMoment, getValidEndTime, getValidStartTime} from './helpers';

import styles from './availability-config.module.css';

type Props = {
    availabilityTimes: AvailabilityTime[];
    onChange: (newTimes: AvailabilityTime[]) => void;
};

export function DayAvailabilityTimes(props: Props) {
    // @ts-expect-error
    const handleTimeChange = (startTime: Moment, endTime: Moment, index: number) => {
        const newAvailabilityTimes = [...props.availabilityTimes];
        // @ts-expect-error
        newAvailabilityTimes[index] = {
            ...newAvailabilityTimes[index],
            startTime: startTime.format('HH:mm'),
            endTime: endTime.format('HH:mm'),
        };

        props.onChange(newAvailabilityTimes);
    };

    return (
        <StackLegacy spacing={8}>
            {props.availabilityTimes.map((time, index) => {
                return (
                    <div key={time.startTime} className={styles['picker-container']}>
                        <StackLegacy isHorizontal={true} spacing={4} alignCenter={true}>
                            <div className={styles['left-picker']}>
                                <SelectTimePicker
                                    maxTime='23:44'
                                    selectedTime={convertTimeStringToMoment(time.startTime)}
                                    // @ts-expect-error
                                    onChange={(newStartTime: Moment) => {
                                        const newEndTime = getValidEndTime(
                                            newStartTime,
                                            time.endTime
                                        );
                                        handleTimeChange(newStartTime, newEndTime, index);
                                    }}
                                />
                            </div>
                            <div className={styles.hyphen}>-</div>
                        </StackLegacy>
                        <div>
                            <div className={styles['right-picker']}>
                                <SelectTimePicker
                                    minTime='00:01'
                                    selectedTime={convertTimeStringToMoment(time.endTime)}
                                    // @ts-expect-error
                                    onChange={(newEndTime: Moment) => {
                                        const newStartTime = getValidStartTime(
                                            time.startTime,
                                            newEndTime
                                        );

                                        handleTimeChange(newStartTime, newEndTime, index);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                );
            })}
        </StackLegacy>
    );
}
